// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const wtvplusColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#0C898A',
  secondary: '#0C898A',
}

export const darkTheme = {
  colors: wtvplusColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: wtvplusColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: wtvplusColors.primaryGray,
    secondary: wtvplusColors.secondaryGray,
    disabled: wtvplusColors.grayText,
    link: wtvplusColors.secondaryGray,
    hint: wtvplusColors.white,
    highlight: wtvplusColors.secondary,
    gray: wtvplusColors.primaryGray,
    seeAll: wtvplusColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: wtvplusColors.primaryGray,
    gray: wtvplusColors.secondaryGray,
  },
  filter: {
    primary: wtvplusColors.primaryGray,
    secondary: wtvplusColors.secondaryGray,
    disabled: wtvplusColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: wtvplusColors.dark,
    color: wtvplusColors.white,
    border: wtvplusColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: wtvplusColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: wtvplusColors.dark,
        selected: wtvplusColors.dark,
        progress: rgba(wtvplusColors.primary, 0.3),
        past: rgba(wtvplusColors.primary, 0.3),
        pastSelected: wtvplusColors.dark,
        pastHover: wtvplusColors.dark,
        empty: '#555555',
        emptyProgress: rgba(wtvplusColors.primary, 0.2),
      },
      text: {
        empty: wtvplusColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: wtvplusColors.white,
    subTitle: wtvplusColors.secondaryGray,
    bg: wtvplusColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 158,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
